module.exports = __webpack_public_path__ + "static/energy_private_6-6f64c343a6c14c19fcf562b86fed0631.jpg";